import styled from 'styled-components'

export const SectionHeading = styled.div`
  font-size: 36px;
  margin: 36px 0;
`
